import { useContext } from 'react';
import ToastContext from './ToastContext';

const useToast = () => {
  const { push, closeAll } = useContext(ToastContext);

  return {
    push,
    closeAll
  };
};

export default useToast;
